import { createWebHistory, createRouter } from 'vue-router';

import OrganisationProvider from '@/components/organisation_provider.vue';

import infoRoutes from './general/info_routes';
import notFoundRoutes from './general/not_found_routes';
import organisationsRoutes from './organisations/organisations_routes';
import plantsRoutes from './plants/plants_routes';
import shaftsRoutes from './shafts/shafts_routes';
import shaftsV2Routes from './shafts/shaftsV2_routes';
import shipsRoutes from './ships/ships_routes';
import equipmentRoutes from './equipment/equipment_routes';
import userRoutes from './users/app_user_routes';
import only from './only'

export const ROUTES = [
  ...infoRoutes,
  ...notFoundRoutes,
  ...organisationsRoutes,
  ...userRoutes,
  {
    path: '/organisations/:organisationId',
    component: OrganisationProvider,
    props: only('organisationId'),
    children: [
      ...plantsRoutes,
      ...shaftsRoutes,
      ...shaftsV2Routes,
      ...shipsRoutes,
      ...equipmentRoutes,
    ]
  }
];

export default function createAppRouter() {
  const router = createRouter({
    history: createWebHistory(),
    routes: ROUTES,
    scrollBehavior: () => {
      return { left: 0, top: 0 };
    },
  });

  return router;
}
